import React, { useContext, useEffect } from "react";
import {
  Navbar,
  Container,
  Offcanvas,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from "react-bootstrap";
import { HiBuildingStorefront, HiMiniBookOpen } from "react-icons/hi2";
import { FaEnvelope } from "react-icons/fa6";
import Images from "../../Helpers/Images";
import { Link } from "react-router-dom";
import { RiMenu2Line } from "react-icons/ri";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import InfluncerProfileDropdown from "./InfluncerProfileDropdown";
import BrandMobileMenuList from "./BrandMobileMenuList";
import InfluencerMobileMenuList from "./InfluencerMobileMenuList";

const MobileHeader = () => {
  const { auth, setAuth, logOut } = useContext(Auth);
  useEffect(() => {
    getUser();
  }, []);
  const getUser = () => {
    let config = {
      url:
        auth?.userRole === "BRAND"
          ? ApiUrl.getBrandProfile
          : ApiUrl.getInfluncerProfile,
      method: "GET",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        localStorage.setItem("user", JSON.stringify(res?.data));
        setAuth({
          ...auth,
          user: res?.data,
        });
      },
      (err) => {
        // setIsLoading(false);
      }
    );
  };
  return (
    <div className="mobile-header-wrapper">
      <Navbar className="mobile-navbar" expand={false}>
        <Container className="mobile-navbar-inner" fluid>
          <Navbar.Brand>
            <Link to="/influencer-dashboard">
              <img src={Images.logo} alt="logo" className="logo" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="offcanvasNavbar"
            className="toggle-wrapper"
          >
            <RiMenu2Line />
          </Navbar.Toggle>
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="start"
            className="mobileMenu-canvas"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">
                {auth?.userRole === "BRAND" ? (
                  <Link to="/brand/dashboard">
                    <img src={Images.logo} alt="logo" className="logo" />
                  </Link>
                ) : (
                  <Link to="/influencer/dashboard">
                    <img src={Images.logo} alt="logo" className="logo" />
                  </Link>
                )}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {auth?.userRole === "BRAND" ? (
                <>
                  <BrandMobileMenuList />
                  <Nav className="common-nav">
                    <Link to="/collaboration-hub">
                      <HiBuildingStorefront />
                      Collaboration Hub
                    </Link>
                    {/* <Link to="/contact-us">
                      <HiMiniBookOpen /> Blog
                    </Link> */}
                    <Link to="/contact-us">
                      <FaEnvelope /> Contact
                    </Link>
                  </Nav>
                </>
              ) : (
                <>
                  <InfluencerMobileMenuList />
                  <Nav className="common-nav">
                    <Link to="/collaboration-hub">
                      <HiBuildingStorefront />
                      Collaboration Hub
                    </Link>
                    {/* <Link to="/contact-us">
                      <HiMiniBookOpen /> Blog
                    </Link> */}
                    <Link to="/contact-us">
                      <FaEnvelope /> Contact
                    </Link>
                  </Nav>
                </>
                // <InfluncerProfileDropdown />
              )}
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
};

export default MobileHeader;
